/**
 * 住所コンポーネント
 */
const AddressInfo = ({ address }) => (
  <span className="address">{address ?? ""}</span>
);

export default AddressInfo;